import * as d3 from 'd3'
import $ from 'jquery';

import { Component, ElementRef, Input, OnChanges, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GlobalCfgFactory } from '@shared/factories/global-cfg/global-cfg.factory';
import { BroadcastService } from '@shared/services/broadcast/broadcast.service';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';

@Component({
  selector: 'heat-map-graph',
  templateUrl: './heat-map-graph.component.html'
})
export class HeatMapGraphComponent implements OnInit, OnChanges {
  skin: string = this.globalCfg.skin;
  reportId: any = this.route.snapshot.params['reportId'];

  heatMapGraph: any = {
    id: this.commonUtilsService.createId(),
    heatPointSelect: null,
    specialGraphAD: false,
    widthGraph: 660,
    heightGraph: 330,
    marginLeftBottom: 58
  }
  constructor(private globalCfg: GlobalCfgFactory,
    private route: ActivatedRoute,
    private broadcastService: BroadcastService,
    private container: ElementRef,
    private commonUtilsService: CommonUtilsService) { }

  @Input() graphData: any = null;

  ngOnInit(): void {
    this.heatMapGraph.specialGraphAD = window.location.host === 'adolfodominguez.lefebvre.es' && this.reportId === '164';
  }

  ngOnChanges(){
    let that: any = this.heatMapGraph;
    if(this.graphData){
      that.graphData = this.graphData.graph;
      that.graph ={};
      this.drawHeatMap();
      this.clickMenu();
    }
  }

  openRisk(risk:any){
    this.broadcastService.broadcast('openRisk', {risk: risk});
  }

  drawHeatMap(){
    this.configureGraph();
    this.generateAsisX();
    this.generateAxisY();
    this.paintGraph();
  }

  configureGraph(){
    let that: any = this.heatMapGraph;
    that.graphData.squareWidth = that.widthGraph / that.graphData.axisX.length;
    that.graphData.squareHeight = that.heightGraph / that.graphData.axisX.length;
    that.graphData.width = that.marginLeftBottom + that.widthGraph;
    that.graphData.height = that.marginLeftBottom + that.heightGraph;

    that.graph.svg = d3.select(this.container.nativeElement.firstChild.firstChild)
        .append("svg")
        .attr('id', 'svg-heat-map-'+this.heatMapGraph.id)
        .attr('height', that.graphData.height)
        .attr("width", that.graphData.width)
        // .attr("viewBox", `0 0 ${that.graphData.width} ${that.graphData.height}`)
        .append("g")
        .attr('class', 'heat-map-graph__heat-map-graph')
        .attr("transform","translate(50, 0)");
    if (this.reportId === "164") {
        that.graph.svg.style("shape-rendering", "crispEdges");
    }
  }

  generateAsisX(){
    let that: any = this.heatMapGraph;
    that.graph.x = d3.scaleBand()
      .range([ 0, that.widthGraph  ])
      .domain(that.graphData.axisX);

    that.graph.svg.append("g")
      .attr("class", "heat-map-graph__axis-x")
      .attr("id", `axxis-x-${this.heatMapGraph.id}`)
      .attr("transform", "translate(-30," + (that.graphData.height-27) + ")")
      .call(d3.axisBottom(that.graph.x).tickSize(0));

    d3.selectAll('.heat-map-graph__axis-x path')
      .attr("stroke-width", 4)
      .attr("stroke", ()=>{
        return this.skin==='gm-law'? '#000000' : '#001978';
      })
      .attr("transform", "translate(30,0)");

    d3.selectAll('.heat-map-graph__axis-x .tick text')
      .attr("transform", "translate(30,10)")
      .attr('class', ()=>{
        return 'heat-map-graph__axis-tick-text heat-map-graph__axis-tick-text--'+ this.skin;
      })

    d3.selectAll(`#axxis-x-${this.heatMapGraph.id}`)
      .append('foreignObject')
      .attr("x", "30")
      .attr("width", that.graphData.width - that.marginLeftBottom)
      .attr("y", "-30")
      .attr("height", "30")
      .append('xhtml:div')
      .attr("class", `heat-map-graph__x-axis-title heat-map-graph__x-axis-title--${this.skin}`)
      .text(this.graphData.xAxxis);
  }

  generateAxisY(){
    let that: any = this.heatMapGraph;
    that.graph.y = d3.scaleBand()
      .range([ that.heightGraph, 0 ])
      .domain(that.graphData.axisY);

    that.graph.svg.append("g")
      .attr("class", "heat-map-graph__axis-y")
      .attr("id", `axxis-y-${this.heatMapGraph.id}`)
      .attr("transform", "translate(-30, 30)")
      .call(d3.axisLeft(that.graph.y).tickSize(0));

    d3.selectAll('.heat-map-graph__axis-y path')
      .attr("stroke-width", 4)
      .attr("stroke", ()=>{
        return this.skin==='gm-law'?'#000000' : '#001978';
      })
      .attr("transform", "translate(0,-30)");

    d3.selectAll('.heat-map-graph__axis-y .tick text')
      .attr("transform", "translate(-10,-25)")
      .attr('class', ()=>{
        return 'heat-map-graph__axis-tick-text heat-map-graph__axis-tick-text--'+ this.skin;
      })

    d3.selectAll(`#axxis-y-${this.heatMapGraph.id}`)
      .append('foreignObject')
      .attr("width", "30")
      .attr("height",  `${that.heightGraph}`)
      .attr("y", "-30")
      .append('xhtml:div')
      .attr("class", `heat-map-graph__y-axis-title heat-map-graph__y-axis-title--${this.skin}`)
      .text(this.graphData.yAxxis);
  }

  paintGraph(){
    let that: any = this.heatMapGraph;
    let heatPoint = that.graph.svg.selectAll()
      .data(that.graphData.data, (d:any)=> {return d.x+':'+d.y;})
      .enter()
      .append("g")

    heatPoint.append('rect')
      .attr("x", (d:any)=> {
        return that.graph.x(d.x)
      })
      .attr("y", (d:any)=> {
        return that.graph.y(d.y)
      })
      .attr("width", that.graphData.squareWidth )
      .attr("height", that.graphData.squareHeight )
      .style("fill", (d:any)=> {
        return d.backgroundColor;
      });

    heatPoint.append('foreignObject')
      .attr("width", that.graphData.squareWidth)
      .attr("height", that.graphData.squareHeight)
      .attr("x", (d:any)=> {
        return that.graph.x(d.x);
      })
      .attr("y", (d:any)=> {
        return that.graph.y(d.y);
      })
      .append('xhtml:div')
      .attr("class", "heat-map-graph__container-risk-value")
      .append('xhtml:div')
      .attr("class", (d:any)=>{
        return d.risks.length?'heat-map-graph__risk-value':'';
      })
      .text((d:any)=>{
        if(d.risks.length){
          return d.risks.length;
        }
      })
      .on("click", (ev: any, d:any)=>{
        if(d.risks.length){
          this.showTooltip(d, ev);
        }
      });
  }

  showTooltip(d:any, ev:any){
    if(this.heatMapGraph.heatPointSelect && this.heatMapGraph.heatPointSelect.cellText === d.cellText){
      this.closeTooltip();
    }else{
      let position: any = this.configurePositionTooltip(d, ev);
      d3.select("#"+this.heatMapGraph.id)
        .style('left', `${position.offsetX}px`)
        .style('top', `${position.offsetY}px`)
        .style('visibility', 'visible')
    }
  }

  configurePositionTooltip(d: any, ev:any){
    let element: any = ev.currentTarget;
    let clientRect = element.getBoundingClientRect();
    let clientText = { clientX: clientRect.left, clientY: clientRect.top};
    let widthTooltip: number = 140;
    let widthHeighContainer: number = 50;
    let offsetX =  d3.pointer(clientText, this.heatMapGraph.graph.svg.node())[0] + widthHeighContainer - (widthTooltip - (clientRect.width/2));
    let offsetY =  d3.pointer(clientText, this.heatMapGraph.graph.svg.node())[1] + widthHeighContainer;
    this.heatMapGraph.heatPointSelect = d;
    return { offsetX: offsetX, offsetY: offsetY };
  }

  closeTooltip(){
    let that: any = this.heatMapGraph
    d3.select("#"+this.heatMapGraph.id)
      .style('visibility', 'hidden');
    that.heatPointSelect = null;
  }

  clickMenu(){
    $(document).off('click', (event)=>{this.closeMenu(event)});
    $(document).on('click', (event)=>{this.closeMenu(event)});
  }

  closeMenu(event:any){
    let that: any = this.heatMapGraph;
    if(typeof event.target.className === 'string'){
      if ( that.heatPointSelect !== null && event.target.className !== undefined && event.target.className.indexOf('heat-map-graph') === -1){
        this.closeTooltip()
      }
    }else if(event.target.className.animVal === '' && event.target.className.baseVal === ''){
      if(that.heatPointSelect !== null){
        this.closeTooltip()
      }
    }
  }
}
